import React from "react";

/* Empty cart illustration: cart with a red "x" badge. Every colour comes from a
   --cart-page-empty-* variable (defaults in scss/index.scss), so each client can
   match its theme from its own cart.css. */
const CELLS = [
  [122, 166, 38, 44], [174, 166, 38, 44], [226, 166, 38, 44], [278, 166, 38, 44], [330, 166, 38, 44],
  [128, 222, 32, 42], [174, 222, 38, 42], [226, 222, 38, 42], [278, 222, 38, 42], [330, 222, 24, 42],
  [134, 276, 26, 40], [174, 276, 38, 40], [226, 276, 38, 40], [278, 276, 38, 40], [330, 276, 10, 40],
];

const EmptyCartIcon = ({ className = "" }) => (
  <svg
    className={`empty-cart-icon ${className}`.trim()}
    viewBox="0 0 512 512"
    aria-hidden="true"
    focusable="false"
  >
    {/* Shadow of the handle, frame and bottom rail */}
    <g className="empty-cart-icon__shadow" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M36 104h48l40 236v12q0 30 30 30h206" strokeWidth="26" />
      <path d="M404 156l-50 180H140" strokeWidth="22" />
    </g>

    {/* Basket body */}
    <path className="empty-cart-icon__body" d="M96 140h300l-54 190H124z" />

    {/* Basket cells, each with a darker left edge */}
    <g className="empty-cart-icon__cell">
      {CELLS.map(([x, y, width, height]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={width} height={height} rx="2" />
      ))}
    </g>
    <g className="empty-cart-icon__cell-edge">
      {CELLS.map(([x, y, , height]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width="8" height={height} />
      ))}
    </g>

    {/* Handle, frame and bottom rail */}
    <g className="empty-cart-icon__frame" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M24 94h46l40 236v14q0 28 28 28h206" strokeWidth="26" />
      <path d="M96 140h300l-54 190H124z" strokeWidth="22" />
    </g>

    {/* Wheels */}
    <circle className="empty-cart-icon__wheel" cx="168" cy="428" r="34" />
    <circle className="empty-cart-icon__wheel" cx="322" cy="428" r="34" />
    <circle className="empty-cart-icon__hub" cx="168" cy="428" r="13" />
    <circle className="empty-cart-icon__hub" cx="322" cy="428" r="13" />

    {/* Remove badge */}
    <circle className="empty-cart-icon__badge-rim" cx="413" cy="136" r="90" />
    <circle className="empty-cart-icon__badge" cx="419" cy="142" r="84" />
    <g strokeWidth="26">
      <path className="empty-cart-icon__mark" d="M370 97l82 82" />
      <path className="empty-cart-icon__mark" d="M452 97l-82 82" />
      <path className="empty-cart-icon__mark-shade" d="M411 138l41 41" />
      <path className="empty-cart-icon__mark-shade" d="M411 138l41 -41" />
    </g>
  </svg>
);

export default EmptyCartIcon;
